import { Box } from '@mui/material'
import React from 'react'

import AppBar from 'components/organisms/AppBar'

const LoginFlowTemplate = ({ children }) => (
  <Box
    className="app-container"
    sx={{
      backgroundColor: (theme) => theme.custom.bodyColor,
    }}
  >
    <AppBar authState="signIn" />

    {children}
  </Box>
)

export default LoginFlowTemplate
